// Wraps window.fetch so an API answer of 503 + {code: "MAINTENANCE"} calls onMaintenance()
// at once (at most every 3s), instead of waiting for the next status poll. Returns an undo function.
export function installMaintenanceFetchHook(base, onMaintenance, win = window) {
  const originalFetch = win.fetch;
  let lastKick = 0;
  win.fetch = async (...args) => {
    const res = await originalFetch.apply(win, args);
    if (res.status === 503 && Date.now() - lastKick > 3000) {
      const url = String(args[0] && args[0].url ? args[0].url : args[0]);
      if (url.startsWith(base)) {
        res.clone().json().then(d => {
          if (d && d.code === 'MAINTENANCE') { lastKick = Date.now(); onMaintenance(); }
        }).catch(() => {});
      }
    }
    return res;
  };
  return () => { win.fetch = originalFetch; };
}
